import { Component, EventEmitter, Input, Output, inject } from "@angular/core";

import { CTAToken } from "@hermes/api-model-common";
import { Edito, Media } from "@hermes/api-model-editorial";

import { MediaPictureCtaComponent } from "@hermes/domains-edito-fragments-media-cta";
import {
    type MenuEntryItemWithEdito,
    MenuAnalyticsService,
} from "@hermes/domains-shell-fragments-menu-shared";

@Component({
    selector: "h-menu-bar-edito",
    imports: [MediaPictureCtaComponent],
    templateUrl: "./menu-bar-edito.component.html",
    styleUrls: ["./menu-bar-edito.component.scss"],
})
export class MenuBarEditoComponent {
    private menuAnalyticsService = inject(MenuAnalyticsService);

    @Input()
    public menuEntry!: MenuEntryItemWithEdito;

    @Input()
    public edito!: Edito;

    @Output()
    public menuEditoClicked: EventEmitter<void> = new EventEmitter<void>();

    public get media(): Media {
        return {
            mobileImage: this.edito.image,
            desktopImage: this.edito.image,
            videoLoopMuteAutoplay: false,
            alwaysShowControls: false,
            imageRetouched: false,
            caption: "",
            credits: "",
            videoUrl: "",
        };
    }

    public get token(): CTAToken {
        return {
            path: this.edito.path,
            text: this.edito.title,
            tokenType: "ctaStory",
        };
    }

    public onMediaRedirection(event?: MouseEvent | Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        this.menuEditoClicked.emit();

        this.menuAnalyticsService.sendAnalyticsOnMenuEditoClick(this.menuEntry);
    }
}
